import { render, staticRenderFns } from "./TeamLicensesEmbed.vue?vue&type=template&id=d10f36f4&scoped=true"
import script from "./TeamLicensesEmbed.vue?vue&type=script&lang=js"
export * from "./TeamLicensesEmbed.vue?vue&type=script&lang=js"
import style0 from "./TeamLicensesEmbed.vue?vue&type=style&index=0&id=d10f36f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10f36f4",
  null
  
)

export default component.exports